module.exports = __webpack_public_path__ + "static/media/icon_co2.461cc325.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon_co2.svg
// module id = 80
// module chunks = 0